import "../../styles/uniBadge.css";

export default function UniBadge({country, name, emblem, keyIndex}: any) {
    return <>
        <div className="unibadgecontainer" key={keyIndex}>
            <img src={emblem} alt="" className="emblem" />
            <div className="infocontainer">
                <div className="country">{country}</div>
                <div className="name">{name}</div>
            </div>
        </div>
    </>;
};